import type { ThemeVariantMap } from "@/theme/types";

import { kfcLightTheme } from "./kfc.light";

export const kfcTheme: ThemeVariantMap = {
  LIGHT: kfcLightTheme,
} as const;
